import { normalizeOperatorName, normalizeQueuePosition } from '@/lib/live-support'
import type { LiveSupportState } from '@/store/chat.store'

type StateUpdaters = {
  setOperatorName: (name: string | null) => void
  setLiveSupportState: (state: LiveSupportState) => void
}

export const createNotificationHandlers = (data: any, updaters: StateUpdaters) => {
  const { setOperatorName, setLiveSupportState } = updaters
  const operatorName = normalizeOperatorName(data?.values?.operator_name)
  const queuePosition = normalizeQueuePosition(data?.queue_position ?? data?.values?.queue_position)

  return {
    operator_joined: () => {
      setOperatorName(operatorName)
      setLiveSupportState({
        in_queue: true,
        status: 'processing',
        ...(operatorName ? { operator_name: operatorName } : {}),
        ...(queuePosition !== undefined ? { queue_position: queuePosition } : {})
      })
    },
    operator_left: () => {
      setOperatorName(null)
      setLiveSupportState({
        in_queue: true,
        status: 'pending',
        ...(queuePosition !== undefined ? { queue_position: queuePosition } : {})
      })
    },
    // Direct takeover released: the AI resumes, so unlike operator_left there
    // is no queue to wait in — just clear the operator banner.
    operator_released: () => {
      setOperatorName(null)
      setLiveSupportState(null)
    },
    resolved: () => {
      setOperatorName(null)
      setLiveSupportState(null)
    },
    connected_to_live_support: () => {
      setLiveSupportState({
        in_queue: true,
        status: 'pending',
        ...(queuePosition !== undefined ? { queue_position: queuePosition } : {})
      })
    },
    queue_position_update: () => {
      setLiveSupportState({
        in_queue: true,
        status: 'pending',
        ...(queuePosition !== undefined ? { queue_position: queuePosition } : {})
      })
    }
  } as Record<string, () => void>
}
